(function($) {
	$.fn.PlateStacker = function(settings) {
		var my;

		my = {
			init: function($containers) {
				my.$containers = $containers;

				settings = window.ob_set(settings || {}, {
					'top_space': 200,
					'assets': {
						'standard': {
							'url': '/assets/stack-plate-blue.png',
							'dimensions': [380, 128],
							'margins': [0, -28]
						},
						'top': {
							'url': '/assets/stack-plate-food-blue.png',
							'dimensions': [381, 204],
							'margins': [0, -28]
						}
					}
				});

				my.status = [];

				my.$containers.each(function(index) {
					my.status.push({
						'bottoms': [],
						'rotations': [],
						'target_rotations': []
					});

					my.prep($(this), index);
					my.animate($(this), index);
				});
			},

			prep: function($container, index) {
				var top_height, standard_height,
					a, asset, asset_bottom, asset_rotation;

				settings.full_height = $container.height();
				settings.height = (settings.full_height - settings.top_space);
				settings.width = $container.width();

				top_height = (settings.assets.top.dimensions[1] + settings.assets.top.margins[1]);
				standard_height = (settings.assets.standard.dimensions[1] + settings.assets.standard.margins[1]);

				settings.num_plates =
					Math.floor((settings.height - top_height) / standard_height) + 1;
				// console.log("i have", settings.height, "px to work with - making", settings.num_plates, "plates (indluding top plate)");

				// set up container
				$container.css({
					'overflow': 'hidden'
				});

				// create plate elements
				for (a = 0; a < settings.num_plates; a += 1) {
					if (a < settings.num_plates - 1) {
						asset = settings.assets.standard;
					} else {
						asset = settings.assets.top;
					}

					if (asset_bottom === undefined) {
						// first item
						asset_bottom = 0 - asset.margins[1];
						asset_rotation = (Math.random() * 10) - 5;
						asset_rotation_target = 0;
					} else {
						asset_rotation = (Math.random() * 20) - 10;
						asset_rotation_target = asset_rotation / 2;
					}

					$container.append(
						$("<span>", {
							'class': 'plate'
						}).css({
							'zIndex': settings.num_plates - a,
							'left': (settings.width / 2) - (asset.dimensions[0] / 2) + 'px',
							'bottom': (settings.full_height - (asset.margins[0] + asset.margins[1] - 10)) + 'px',
							'width': asset.dimensions[0] + 'px',
							'height': asset.dimensions[1] + 'px',
							'marginTop': asset.margins[0] + 'px',
							'marginBottom': asset.margins[1] + 'px',
							'backgroundImage': 'url(' + asset.url + ')',
							'transform': 'rotate(' + asset_rotation + 'deg)'
						})
					);

					my.status[index].bottoms.push(asset_bottom);
					my.status[index].rotations.push(asset_rotation);
					my.status[index].target_rotations.push(asset_rotation_target);

					asset_bottom += asset.dimensions[1] + asset.margins[0] + asset.margins[1];
				}
			},

			animate: function($container, index) {
				var $plates, fn_animate;

				fn_animate = function(a) {
					var step_2, bottom;

					// console.log("animating plate", index, "to", my.status[index].bottoms[a]);

					if (index === 0) {
						bottom = my.status[index].bottoms[a];
					} else {
						bottom = (my.status[index].bottoms[a] - 5);
					}

					$plates.eq(a).animate({
						'bottom': bottom + 'px'
					}, {
						'duration': 400,
						'easing': 'easeOutQuart',
						'step': function(now, tween) {
							if (tween.pos > 0.8 && !step_2) {
								step_2 = true;

								$plates.eq(a).animate({
									'bottom': my.status[index].bottoms[a] + 'px'
								}, {
									'duration': 200,
									'easing': 'easeOutQuart'
								});

								$({
									'deg': my.status[index].rotations[a]
								}).animate({
									'deg': my.status[index].target_rotations[a]
								}, {
									'duration': 200,
									'step': function(now) {
										$plates.eq(a).css({
											'transform': 'rotate(' + now + 'deg)'
										});
									}
								});

								if (a < $plates.length) {
									fn_animate(a + 1);
								}
							}
						}
					});
				};

				$plates = $container.find(".plate");

				if ($plates.length > 0) {
					fn_animate(0);
				}
			}
		};

		my.init(this, Array.prototype.slice.call(arguments, [1]));
	};

}(window.jQuery));
